import Tooltip from './Tooltip';

export { Props } from './Tooltip';
export default Tooltip;
